import globalMU from "globalMU";
import { BaseApi } from "./BaseApi";
import { OrcamentoWebSnapshot } from "app/types/orcamentoWebSnapshot/OrcamentoWebSnapshot";
import { AxiosRequestConfig } from "axios";

export class OrcamentoWebSnapshotApi extends BaseApi {
    
    url(path: string): string {
        return `${globalMU.enterpriseUrl()}/api/${path}`;
    }

    async adicionarSnapshot(oidVendedor: string, oidSessaoAplicativo: number, oidFilial: number): Promise<OrcamentoWebSnapshot> {
        const token = globalMU.token();

        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };

        const respsota = await this.Enterprise.post(this.url("orcamentowebsnapshots/adicionarsnapshot"),
            { oidVendedor, oidSessaoAplicativo, oidFilial }
            , config);
        return respsota.data;

    }

}